import {Component,  OnInit} from '@angular/core';
import {DataStorageService} from './../data-storage.service';
import {AvailableComponents} from './enumAvailableComponents';
import {Router} from '@angular/router';
import {AvailableComponentsURLs} from '../../enumAvailableComponentsURLs';
import {SecurityService} from '../security.service';

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.scss']
})
export class SideBarComponent implements OnInit {

  constructor(public dataStorageService: DataStorageService,
              public securityService: SecurityService,
              private router: Router) {

  }

 ngOnInit() {}

  onPreviousClick() {
    if (this.dataStorageService.currentComponent > -1) {
      this.dataStorageService.currentComponent--;
      for (let i = this.dataStorageService.currentComponent; i > -1; i--) {
        console.log(this.dataStorageService.currentComponent);
        if (this.dataStorageService.currentState.wishedSolution[AvailableComponents[i]] || i === AvailableComponents.FollowUp) {
          this.router.navigate(['/' + AvailableComponentsURLs[i]]);
          return;
        }
      }
    }
    // for (let i = 12; i > this.dataStorageService.currentComponent; i--) {
    //   if (this.dataStorageService.currentState.wishedSolution[AvailableComponents[i]] || i === AvailableComponents.FollowUp) {
    //     this.router.navigate(['/' + AvailableComponentsURLs[i]]);
    //     return;
    //   }
    // }
  }

  onNextClick() {
    if (this.dataStorageService.currentComponent < AvailableComponentsURLs.offerSummary) {
      this.dataStorageService.currentComponent++;
      for (let i = this.dataStorageService.currentComponent; i <= AvailableComponentsURLs.offerSummary; i++) {
        if (this.dataStorageService.currentState.wishedSolution[AvailableComponents[i]] || i === AvailableComponents.FollowUp) {
          console.log(this.dataStorageService.currentComponent);
          this.router.navigate(['/' + AvailableComponentsURLs[i]]);
          return;
        }
      }
      return;
    }
    // for (let i = 0; i < this.dataStorageService.currentComponent; i++) {
    //   if (this.dataStorageService.currentState.wishedSolution[AvailableComponents[i]] || i === AvailableComponents.FollowUp) {
    //     this.router.navigate(['/' + AvailableComponentsURLs[i]]);
    //     return;
    //   }
    // }
  }
  newOfferStateDetection(e: any) {
    this.dataStorageService.newOfferOpened = <boolean> e;
  }

  disableBtn() {
    if ( this.dataStorageService.currentComponent >= AvailableComponentsURLs.offerSummary) {
      return true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/side-bar/side-bar.component.ts